import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classnames from 'clsx';

import { Pill } from 'ui-components/components/pill';

import { messages } from './messages';
import styles from './new-feature-badge.module.css';

export const NewFeatureBadge = ({ className = '' }) => {
  return <Pill className={classnames(styles['new-pill'], className)} label={<FormattedMessage {...messages.new} />} />;
};

NewFeatureBadge.propTypes = {
  className: PropTypes.string,
};
